import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { supabase } from '../lib/supabase';

export const VerifyLogin: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'verifying' | 'success' | 'error'>('verifying');
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const verify = async () => {
      try {
        // 检查当前会话状态
        const { data: { session } } = await supabase.auth.getSession();
        
        if (session) {
          console.log('Session found, redirecting to dashboard');
          setStatus('success');
          navigate('/dashboard', { replace: true });
          return;
        }

        // 如果没有会话，检查URL参数
        const error = searchParams.get('error');
        const errorDescription = searchParams.get('error_description');

        if (error) {
          console.error('Verification error:', error, errorDescription);
          setError(errorDescription || 'Verification failed');
          setStatus('error');
          return;
        }

        // 检查是否有token参数（从邮件链接跳转）
        const token = searchParams.get('token');
        const email = searchParams.get('email');

        if (token && email) {
          const { data, error: verifyError } = await supabase.auth.verifyOtp({
            token,
            email,
            type: 'email'
          });

          if (verifyError) {
            console.error('OTP verification error:', verifyError);
            setError(verifyError.message);
            setStatus('error');
            return;
          }

          if (data.session) {
            console.log('OTP verification successful, session:', data.session);
            // 确保会话被保存
            await supabase.auth.setSession(data.session);
            setStatus('success');
            // 立即重定向到 dashboard
            navigate('/dashboard', { replace: true });
            return;
          }
        }

        setError('Invalid verification link');
        setStatus('error');
      } catch (err) {
        console.error('Verification error:', err);
        setError('An unexpected error occurred');
        setStatus('error');
      }
    };

    verify();
  }, [navigate, searchParams]);

  return (
    <div className="min-h-screen bg-black flex items-center justify-center">
      <div className="max-w-md w-full bg-gray-900/50 p-8 rounded-xl border border-white/10">
        {status === 'verifying' && (
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-500 mx-auto"></div>
            <p className="mt-4 text-gray-300">验证中...</p>
          </div>
        )}

        {status === 'success' && (
          <div className="text-center">
            <div className="text-green-500 text-4xl mb-4">✓</div>
            <p className="text-gray-300">验证成功，正在跳转...</p>
          </div>
        )}

        {status === 'error' && (
          <div className="text-center">
            <div className="text-red-500 text-4xl mb-4">✗</div>
            <p className="text-red-400">{error}</p>
            <button
              onClick={() => navigate('/login', { replace: true })}
              className="mt-4 px-4 py-2 bg-purple-600 hover:bg-purple-700 rounded-lg text-white"
            >
              返回登录
            </button>
          </div>
        )}
      </div>
    </div>
  );
}; 